import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    paperRoot: {
      marginTop: 32,
      paddingBottom: theme.spacing(2),
    },
    gridContainer: {
      padding: theme.spacing(2),
    },
    scopeFilter: {
      marginTop: 8,
    },
    contentFilters: {
      marginBottom: 28,
    },
    formControl: {
      width: '100%',
    },
    contentImage: {
      width: 20,
      height: 20,
      background: '#E1E8ED',
      borderRadius: 20,
      margin: '0px 8px',
    },
    contentRecipient: {
      display: 'flex',
      alignItems: 'center',
      height: 32,
      background: ' #F5F8FA',
      borderRadius: 16,
      margin: '0px 8px 8px 8px',
    },
    contentArrayRecipient: {
      display: 'grid',
      alignItems: 'center',
      height: 160,
      border: '1px solid #E1E8ED',
      borderRadius: 8,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      marginBottom: 16,
      padding: '12px 8px',
      gridTemplateRows: '0.1fr 1fr',
    },
    recipient: {
      fontSize: 12,
      whiteSpace: 'nowrap',
    },
    content: {
      padding: theme.spacing(3),
    },
    label: {
      margin: '16px 0px 8px 0px',
      fontSize: 14,
    },
    title: {
      margin: '16px 0px 8px 0px',
    },
    firstDivider: {
      marginTop: 24,
    },
    radioGroup: {
      display: 'grid',
    },
    onarmentDiv: {
      width: 10,
      height: 34,
      margin: '0px 6px 32px 0px',
      borderBottom: ' 2px solid #E1E8ED',
      borderLeft: ' 2px solid #E1E8ED',
    },
    icon: {
      borderRadius: '50%',
      width: 16,
      height: 16,
      border: '1px solid #E1E8ED',
      'input:disabled ~ &': {
        boxShadow: 'none',
        border: '2px solid #E1E8ED',
      },
    },
    checkedIcon: {
      borderRadius: '50%',
      width: 18,
      height: 18,
      boxShadow:
        'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
      backgroundColor: '#f5f8fa',
      backgroundImage: 'linear-gradient(90deg, #0094FF 0%, #0094FF 100%)',
      '$root.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },
      'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
      },
    },
    contentFormLabel: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 10,
    },
    contentInput: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minWidth: 175,
      minHeight: 32,
      marginLeft: 16,

      border: '1px solid #E1E8ED',
      borderRadius: 8,
    },
    contentTitleLote: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 360,
      minHeight: 30,
      border: '1px solid #E1E8ED',
      borderRadius: 8,
      marginBottom: 16,
      '& > div': {
        width: '100%',
        height: '100%',
        margin: 8,
        '& > p': {
          color: 'red',
        },
      },
      '& fieldset': {
        border: 'none',
      },
      '& input': {
        padding: 0,
      },
    },
    contentInputHour: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minWidth: 88,
      minHeight: 32,
      border: '1px solid #E1E8ED',
      borderRadius: 8,
      marginLeft: 8,
      paddingRight: 8,

      '& input': {
        maxWidth: 40,
        border: 'none',

        '&:focus-visible': {
          outline: '-webkit-focus-ring-color auto 0px !important',
        },
      },
    },
    contentInputDate: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      maxWidth: 156,
      minHeight: 32,
      paddingLeft: 8,
      border: '1px solid #E1E8ED',
      borderRadius: 8,
      marginLeft: 8,
      '& div ': {
        margin: 0,
        '& .MuiInput-underline.Mui-disabled:before': {
          display: 'none',
        },
      },
      '& div p': {
        display: 'none',
      },

      '& div div::before': {
        border: 'none',
      },
      '& div div::after': {
        border: 'none',
      },
      '& div div:hover:not(.Mui-disabled):before': {
        border: 'none',
      },
    },
    contentInputOcorrency: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 64,
      minHeight: 32,
      border: '1px solid #E1E8ED',
      borderRadius: 8,
      marginRight: 12,

      '& input': {
        maxWidth: 36,
        border: 'none',
        marginLeft: 8,
        marginRight: 8,

        '&:focus-visible': {
          outline: '-webkit-focus-ring-color auto 0px !important',
        },
      },
    },

    filtersAgrupmentsReports: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: 180,
      height: 30,
      padding: 12,
      border: '1px solid #0094FF',
      borderRadius: 10,
      cursor: 'pointer',
      fontSize: 13,
      color: '#0094FF',
    },
    badge: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 16,
      height: 16,
      fontSize: 8,
      borderRadius: '50%',
      background: '#EA9427',
      color: theme.palette.colors.white,
    },
    input: {
      margin: 0,
      '& div': {
        maxHeight: 36,
        maxWidth: 48,
        marginLeft: 8,
        '& fieldset': {
          border: 'none',
        },
        '& input': {
          padding: 0,
        },

        /* Chrome, Safari, Edge, Opera */
        '& input::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',

          /* Firefox */
          '-moz-appearance': 'textfield',
          margin: 0,
        },
      },
    },
    searchInput: {
      '& div': {
        maxWidth: 360,
        padding: 0,
        '& fieldset': {
          border: 'none',
        },
      },
    },
    autoComplete: {
      maxHeight: 32,
      margin: 0,
      position: 'relative',
      bottom: 14,
      '& div div': {
        margin: 0,
        '& > p': {
          color: 'red',
        },
      },
    },

    selectInput: {
      padding: 0,
      maxHeight: 36,
      '& div div': {
        minWidth: 120,
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
    dividerVertical: {
      '&:fist-child': {
        background: '#fff',
      },
      background: '#E1E8ED',
      marginRight: 8,
      height: 24,
      margin: '4px 0px',
    },
    boxNoChecked: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 40,
      height: 30,
      border: '1px solid #0094FF',
      borderRadius: 8,
      margin: '0px 8px',
    },
    boxChecked: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 40,
      height: 30,
      background: '#0094FF',
      borderRadius: 8,
      margin: '0px 8px',
    },
    textIconNoChecked: {
      fontSize: 12,
      color: '#0094FF',
    },
    textIconChecked: {
      fontSize: 12,
      color: '#fff !important',
    },
    addButton: {
      background: '#0094FF',
      borderRadius: 12,
      color: '#fff',
      maxHeight: 40,
      // Removed marginTop: 16, it will be handled by buttonContainer
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    buttonContainer: {
      paddingLeft: theme.spacing(3),
      paddingTop: theme.spacing(3), // Space from the form
      paddingBottom: theme.spacing(3), // Consistent padding at the bottom
    },
  }),
);

export default useStyles;
